import { HostFamilyLecComment } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-comment'
import { HostFamilyLecCommentRequest } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createHostFamilyLecComment = async (
  input: HostFamilyLecCommentRequest & { hostFamilyId: number }
) => {
  const { hostFamilyId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.hostFamilies.createHostFamilyLecComment.url, { hostFamilyId }))
    .post<HostFamilyLecComment, HostFamilyLecCommentRequest>(data)
}
